import { colorsPalettes } from "@similarweb/styles";

import type { MenuItem } from "app/pages/sales-intelligence/common-components/options-menu/types";

const RENAME_MENU_ITEM: MenuItem = {
    id: "rename",
    iconName: "edit-icon",
    text: { key: "si.common.button.rename" },
};

const DELETE_MENU_ITEM: MenuItem = {
    id: "delete",
    iconName: "delete",
    text: { key: "si.common.button.delete" },
};

const EDIT_MENU_ITEM: MenuItem = {
    id: "edit",
    iconName: "settings",
    text: { key: "si.common.button.settings" },
};

const LOGS_MENU_ITEM: MenuItem = {
    id: "logs",
    iconName: "document",
    iconStroke: colorsPalettes.carbon["200"],
    text: { key: "si.common.button.logs" },
};

export const getCRMEnrichmentMenuItems = (isLogsAvailable: boolean, isReadOnly: boolean): readonly MenuItem[] => {
    const menuItems = isLogsAvailable
        ? [EDIT_MENU_ITEM, LOGS_MENU_ITEM, RENAME_MENU_ITEM, DELETE_MENU_ITEM].filter(Boolean)
        : [EDIT_MENU_ITEM, RENAME_MENU_ITEM, DELETE_MENU_ITEM];

    return isReadOnly ? menuItems.map((item) => (item.id === "logs" ? item : { ...item, disabled: true })) : menuItems;
};
